import { Injectable } from "@angular/core";
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { KYMW1002Model } from '../kymw1002.model';
import { DashboardLockInfoList } from '../vo/dashboard-lock-info.model';

// レスポンス構造
interface GetDashboardLockInfoResponse {
  LockInfoList: {
    /** 受注コード */
    OrderCode: string;
    /** 媒体区分 */
    MediumType: string;
    /** Ｐコード */
    PCode: string;
    /** ページID */
    PageId: number;
    /** ページ番号 */
    PageNum: number;
    /** 処理名 */
    ProcessName: string;
    /** ロック開始日時 */
    LockStartDate: string;
    /** ロック実施者 */
    LockerName: string;
    /** ロック種別 */
    LockType: string;
    /** ロック実施者ID */
    LockerId: string;
  }[];
}

/**
 * ダッシュボード画面 ロック情報を取得するサービス
 *
 * @export GetDashboardLockInfoService
 * @class GetDashboardLockInfo
 * @extends {PlessResponder}
 */
@Injectable()
export class GetDashboardLockInfoService extends PlessJsonResponderSub<any> {
  private model: KYMW1002Model;
  private successFunc: Function;
  private type: string;
  private lockInfoType: Object = {
    init: 'init',
    release: 'release',
    update: 'update'
  };

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof GetDashboardLockInfoService
   */
  private getBody(): PlessRequest {
    return new PlessRequest();
  }

  /**
   * API呼び出し
   *
   * @param {KYMW1002Model} model モデルクラス
   * @param {string} type 呼び出し種別(init:初回起動時 update:更新ボタン押下時 release:ロック解除ボタン押下時)
   * @param {Function} successFunc 成功時後続処理
   * @memberof GetDashboardLockInfoService
   */
  execute(model: KYMW1002Model, type: string, successFunc: Function): void {
    this.model = model;
    this.type = type;
    this.successFunc = successFunc;
    this.send('getDashboardLockInfo', this.getBody());
  }


  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof GetDashboardLockInfoService
   */
  success(data: GetDashboardLockInfoResponse): void {
    // 初回起動時
    if (this.type === this.lockInfoType['init']) {
      // 取得データを格納
      this.model.dashboardLockInfoList = this.convertToModel(data);
      // 成功時後続処理
      if (data !== null) {
        this.successFunc();
      }
    }
    // 更新ボタン押下時 
    else if (this.type === this.lockInfoType['update']) {
      // 表示用データをクリア
      this.model.getUpdLockInfo();
      // 取得データを格納
      this.model.dashboardLockInfoList = this.convertToModel(data);
      // 成功時後続処理
      if (data !== null) {
        this.successFunc();
      }
    }
    // ロック解除ボタン押下時
    else {
      if (this.model.editDashboardLockInfoList.length > 0) {
        this.model.showDashboardLockInfoList = this.model.editDashboardLockInfoList;
      }
      // 成功時後続処理
      if (data !== null) {
        this.successFunc();
      }
    }
  }

  /**
   * API通信失敗時の処理
   *
   * @param {string} status エラーステータス
   * @param {*} result エラー結果
   * @memberof GetDashboardLockInfoService
   */
  exceptionError(status: string, result: any): void {
    super.exceptionError(status, result);
  }

  // API レスポンスをコンポーネント用モデルに変換
  private convertToModel(data: GetDashboardLockInfoResponse): DashboardLockInfoList {
    return {
      LockInfoList: data.LockInfoList.map(res => (
        {
          OrderCode: res.OrderCode,
          MediumType: res.MediumType,
          PCode: res.PCode,
          PageId: Number(res.PageId),
          PageNum: Number(res.PageNum),
          ProcessName: res.ProcessName,
          LockStartDate: res.LockStartDate,
          LockerName: res.LockerName,
          LockType: res.LockType,
          LockerId: res.LockerId,
        }
      ))
    };
  }
}
